// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"u7-z"};